<template>
  <v-btn
    class="custom-btn"
    :class="classes"
    :style="styles"
    :color="color"
    :small="small || !hasContent"
    :text="text"
    rounded
    depressed
    :ripple="ripple"
    :outlined="outlined"
    :block="block"
    :to="to"
    :href="href"
    :target="target"
    :rel="rel"
    :loading="loading"
    :disabled="disabled"
    :type="type"
    @click="$emit('click', $event)"
  >
    <v-icon
      v-if="icon"
      :size="iconSize"
      :color="iconColor"
      :class="{ 'mr-1': hasContent }"
    >
      {{ icon }}
    </v-icon>
    <slot></slot>
    <v-icon
      v-if="appendIcon"
      :size="iconSize"
      :color="iconColor"
      :class="{ 'ml-2': hasContent }"
    >
      {{ appendIcon }}
    </v-icon>
  </v-btn>
</template>

<script>
import { APP_COLORS } from "@/config/app-colors";

export default {
  name: "UiButton",
  props: {
    color: {
      type: String,
      default: "default"
    },
    icon: String,
    appendIcon: String,
    iconSize: {
      type: String,
      default: "22"
    },
    iconColor: String,
    textColor: String,
    minWidth: String,
    readonly: Boolean,
    shadow: Boolean,
    text: Boolean,
    transparent: Boolean,
    outlined: Boolean,
    block: Boolean,
    loading: Boolean,
    small: Boolean,
    disabled: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    type: {
      type: String,
      default: "button"
    },
    to: {
      type: [Object, String, Array],
      default: undefined
    },
    href: String,
    target: String,
    rel: String
  },
  computed: {
    classes() {
      return {
        "custom-btn--default": this.color === "default" && !this.text,
        "custom-btn--icon":
          !this.hasContent && (!!this.icon || !!this.appendIcon),
        "custom-btn--readonly": this.readonly,
        "custom-btn--shadow": this.shadow,
        "custom-btn--link": this.text,
        "custom-btn--transparent": this.transparent
      };
    },
    styles() {
      const styles = {
        color: this.textColor
          ? this.textColor
          : this.color === "default"
          ? APP_COLORS.TEXT
          : APP_COLORS.LIGHT
      };

      if (this.minWidth) {
        styles["min-width"] = this.minWidth.includes("px")
          ? this.minWidth
          : `${this.minWidth}px`;
      }
      return styles;
    },
    hasContent() {
      return !!this.$slots.default;
    }
  }
};
</script>
